import { useQuery } from '@tanstack/react-query';
import { QueryKey } from '@/Config/api/queryKey';
import { TopicDto } from '@/Domain/api/Conversation/dto/Topic.dto';

export const useConversationTopicsList = () => {
  const query = useQuery<TopicDto[]>({
    queryKey: [QueryKey.conversationTopics.list],
  });

  const hasFilledTopic = query.data?.some(({ topic }) => !!topic.trim());

  return { ...query, hasFilledTopic };
};
